import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @author VSm
 * @created on Dec 31 2019
 * @copyOf packages/common-be/src/data-processing/model/DpConfigDefaults.ts
 */
import { DomainObject } from '@logio/common-be-fe';
export var DpConfigDefaults =
/*#__PURE__*/
function (_DomainObject) {
  _inherits(DpConfigDefaults, _DomainObject);

  // tslint:disable-next-line:prettier
  function DpConfigDefaults(attempts, timeout) {
    var _this;

    _classCallCheck(this, DpConfigDefaults);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DpConfigDefaults).call(this));
    _this.attempts = attempts;
    _this.timeout = timeout;
    return _this;
  }

  return DpConfigDefaults;
}(DomainObject);